// this is an autogenerated file from App/Account/Content/Settings/Content/TreatmentPlanTemplates/TxPlanTemplates/LocationChooser/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_TreatmentPlanTemplates_TxPlanTemplates_LocationChooser{
  session_user_locations(order_by: { name: asc }) {
    id
    text: name
  }
}

`